import React from 'react';

// Extracted from StudentProfile.js's renderHomeworkSection (Phase 3 of the
// platform-health plan: split the file mechanically, without changing
// behavior).
export default function HomeworkTab({
  homeworkFilter,
  onFilterChange,
  homeworkLoading,
  homework,
  onCheckHomework,
  onDeleteHomework,
}) {
  const filtered = (homework || [])
    .filter(hw => {
      if (homeworkFilter === 'all') return true;
      if (homeworkFilter === 'assigned') {
        // Показываем assigned и submitted (до проверки)
        return hw.status === 'assigned' || hw.status === 'submitted';
      }
      if (homeworkFilter === 'reviewed') {
        // Показываем только проверенные
        return hw.status === 'reviewed';
      }
      return hw.status === homeworkFilter;
    })
    .sort((a, b) => {
      // Assigned/submitted (needs the teacher's attention) first,
      // reviewed ones last — same idea as Lessons showing the
      // most relevant rows up top.
      const priority = (status) => (status === 'reviewed' ? 1 : 0);
      return priority(a.status) - priority(b.status);
    });

  return (
    <div className="homework-tab-content section-card">
      <div className="homework-header">
        <div className="homework-filter-tabs">
          <button
            className={`filter-tab ${homeworkFilter === 'all' ? 'active' : ''}`}
            onClick={() => onFilterChange('all')}
          >
            All
          </button>
          <button
            className={`filter-tab ${homeworkFilter === 'assigned' ? 'active' : ''}`}
            onClick={() => onFilterChange('assigned')}
          >
            Assigned
          </button>

          <button
            className={`filter-tab ${homeworkFilter === 'reviewed' ? 'active' : ''}`}
            onClick={() => onFilterChange('reviewed')}
          >
            Reviewed
          </button>
        </div>
        <button className="add-homework-btn">
          <svg width="16" height="16" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path d="M12 5v14M5 12h14" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
          </svg>
          Send Homework
        </button>
      </div>

      <div className="homework-list">
        {homeworkLoading ? (
          <div className="homework-loading-message">
            <span className="homework-loading-spinner" aria-hidden />
            <span>Loading homework…</span>
          </div>
        ) : filtered.map(hw => (
          <div
            key={hw.id}
            className={`homework-item homework-item-status-${hw.status || 'draft'}`}
            onClick={() => onCheckHomework(hw.id)}
            style={{ cursor: 'pointer' }}
          >
            <div className="homework-info">
              <h3 className="homework-title">{hw.title || 'Untitled Homework'}</h3>
              <div className="homework-meta">
                <span className="due-date">Due: {hw.dueDate ? new Date(hw.dueDate).toLocaleDateString() : 'No due date'}</span>
                <span className={`status-badge ${hw.status || 'draft'}`}>
                  {(hw.status || 'draft').charAt(0).toUpperCase() + (hw.status || 'draft').slice(1)}
                </span>
                {hw.grade && (
                  <span className="grade-badge">Grade: {hw.grade}%</span>
                )}
              </div>
            </div>

            <div className="homework-actions" onClick={(e) => e.stopPropagation()}>
              {((hw.status || 'draft') === 'assigned' || (hw.status || 'draft') === 'submitted') && (
                <button className="action-btn submit-btn" onClick={() => onCheckHomework(hw.id)}>
                  Check Homework
                </button>
              )}

              {(hw.status || 'draft') === 'reviewed' && (
                <button className="action-btn view-btn" onClick={() => onCheckHomework(hw.id)}>
                  View Feedback
                </button>
              )}
              <button className="action-btn details-btn">
                View Details
              </button>
              <button
                className="action-btn delete-btn"
                onClick={(e) => {
                  e.stopPropagation();
                  onDeleteHomework(hw.id);
                }}
                title="Delete Homework"
              >
                <svg width="16" height="16" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                  <path d="M3 6h18M19 6v14a2 2 0 0 1-2 2H7a2 2 0 0 1-2-2V6m3 0V4a2 2 0 0 1 2-2h4a2 2 0 0 1 2 2v2" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
                </svg>
              </button>
            </div>
          </div>
        ))}

        {!homeworkLoading && filtered.length === 0 ? (
          <div className="no-homework-message">
            <svg width="48" height="48" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
              <path d="M3 9l9-7 9 7v11a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2z"/>
              <polyline points="9,22 9,12 15,12 15,22"/>
            </svg>
            <p>No homework found for this filter.</p>
          </div>
        ) : null}
      </div>
    </div>
  );
}
